<template>
  <div class="media-image-detail">
    <el-form class="user-from" label-width="120px" >
      <el-form-item class="label-line-height" :label="form.forumId == 1? '视频封面':'上传图片'" >
        <el-upload
          :on-success="handleSuccess"
          :on-error="handleError"
          :before-upload="beforeAvatarUpload"
          :show-file-list="false"
          :data="dataObj"
          :action="qiniuUp"
          :accept="accept"
          class="upload-size"
          list-type="picture-card">
          <el-popover
            placement="top-start"
            trigger="hover">
            <div class="popover-content"><img :src="form.image | ImageFormats" alt="img"/></div>
            <img slot="reference" v-show="form.image" :src="form.image | ImageFormats" >
          </el-popover>
          <i v-show="!form.image" class="el-icon-plus avatar-uploader-icon"/>
          <div slot="tip" class="el-upload__tip">只能上传图片，建议不超过10Mb</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="标题">
        <el-input
          class="cms-title"
          v-model="form.title"
          placeholder="请输入标题"/>
      </el-form-item>
      <el-form-item label='视频地址(最大50M)' v-if="form.forumId == 1">
        <el-row>
          <el-col :span="16">
            <el-input
              class="cms-title"
              v-model="form.videoUrl"
              placeholder="请输入视频地址"/>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="7">
            <el-upload
              :on-success="handleVideoSuccess"
              :on-error="handleVideoError"
              :before-upload="beforeVideoUpload"
              :on-progress="handleVideoProgress"
              :show-file-list="false"
              :multiple="false"
              :data="dataVideoObj"
              :action="qiniuUp"
              :accept="acceptVideo">
              <el-button type="primary">上传{{videoPercent > 0 && videoPercent < 100? '(' + videoPercent + '%)' : ''}}</el-button>
              <el-button type="primary" @click="handlePlay" >播放</el-button>
            </el-upload>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="链接">
        <el-input
          class="cms-title"
          v-model="form.url"
          placeholder="请输入链接"/>
      </el-form-item>
      <el-form-item label="顺序(升序)" >
        <el-input
          v-model="form.seq"
          type="Number"
          placeholder="请输入整数(>0)"/>
      </el-form-item>
      <el-form-item label="状态" >
        <el-radio-group v-model="form.status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="-1">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button :loading="isLoading" type="primary" @click="submitAction" >提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { varConfig, showMessage, ImageFormat, ConstConfig } from '@/utils'
  import { getQiniuUploadToken } from '@/api/site'
  import { getSubject, updateMediaSubject, createMediaSubject } from '@/api/cms'

  export default {
    name: 'MediaDetails',
    data() {
      return {
        dataObj: { token: '' },
        dataVideoObj: { token: '' },
        qiniuUp: varConfig.qiniuUp,
        accept: ConstConfig.accept,
        acceptVideo: ConstConfig.acceptVideo,
        videoPercent: 0,
        form: {
          id: null,
          image: '',
          title: null,
          url: '',
          seq: 1,
          status: 0
        },
        isLoading: false,
        routerParams: {}
      }
    },
    created() {
      this.routerParams = this.$route.params
      this.form.forumId = parseInt(this.routerParams.forumId, 10)
      this.getQiniuToken()
      if(this.routerParams.subjectId) {
        this.getSubject()
      }
    },
    watch: {
      $route() {
        this.routerParams = this.$route.params
        this.getQiniuToken()
        if(this.routerParams.subjectId) {
          this.getSubject()
        }
      }
    },
    mounted() {},
    methods: {
      getSubject() {
        const params = this.$route.params
        getSubject({id: params.subjectId}).then(response => {
          this.form= response.data.subject
        })
      },
      createSubject() {
        this.form.forumId = parseInt(this.routerParams.forumId, 10)
        createMediaSubject(this.form).then(resolve=>{
          this.isLoading = false
          if(!resolve) return
          const data = resolve.data
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          if(this.routerParams.forumId == 0) {
            this.$router.replace({
              path: `/media/image/details/${data.subject.id}/${this.routerParams.forumId}`
            })
          } else {
            this.$router.replace({
              path: `/media/video/details/${data.subject.id}/${this.routerParams.forumId}`
            })
          }
        }, reject=>{
          this.isLoading = false
          this.$message.error('数据保存失败')
        })
      },
      updateForm() {
        this.isLoading = true
        updateMediaSubject(this.form).then((resolve) => {
          this.isLoading = false
          this.$message({
            message: '更新成功',
            type: 'success'
          })
        }, (reject) => {
          this.isLoading = false
          this.$message.error('数据保存失败')
        })
      },
      handlePlay() {
        if(this.form.videoUrl) {
          window.open(this.form.videoUrl, '_blank')
        }
      },
      handleSuccess(response) {
        this.form.image = response.hash
      },
      handleVideoSuccess(response) {
        this.form.videoUrl = "http://image.bjh.snsports.cn/" + response.hash
      },
      handleError(file) {
      },
      handleVideoError(file) {
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 10
        if (!isLt2M) {
          showMessage('error', '上传头像图片大小不能超过 10MB!')
        }
        return isLt2M
      },
      beforeVideoUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 50
        if (!isLt2M) {
          showMessage('error', '上传视频大小不能超过 50MB!')
        }
        return isLt2M
      },
      handleVideoProgress(e, f, l){
        this.videoPercent = parseInt(e.percent);
      },
      getQiniuToken() {
        getQiniuUploadToken().then(response => {
          const data = response.data
          this.dataObj.token = data.token
          this.dataVideoObj.token = data.token
        }).catch(err => {
          console.log(err, 'error', '七牛Token获取失败')
        })
      },
      submitAction() {
        if(this.routerParams && this.routerParams.subjectId) {
          this.updateForm()
        } else {
          this.createSubject()
        }
      }
    },
    filters: {
      ImageFormats(img) {
        return ImageFormat.squareImageView(img, 156)
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  #app .cms-title input{
    max-width: 900px;
  }
  .media-image-detail {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .upload-size .el-upload {
      width: 80px;
      height: 80px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 78px;
      height: 78px;
      line-height: 78px !important;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
    }

    .upload-size .el-upload:hover {
      border-color: #409EFF;
    }

    .upload-size .el-upload-list li {
      width: 80px;
      height: 80px;
    }

    .user-from .el-form-item__label {
      text-align: left;
      padding-left: 15px;
    }

    .certificate-upload-style {
      width: 120px;
      height: 32px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      color: #999999;
      line-height: 32px;
    }

    .font-size-style {
      font-size: 14px;
      color: #169BD5;
      padding-left: 20px;
    }

    .team-info-width {
      width: auto;
      margin-right: 12px;
    }

    .el-upload img {
      width: 78px;
      height: 78px;
    }

    .el-popover .popover-content img {
      max-width: 720px;
    }
  }
</style>
